exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yxp-uploader .btn[data-v-7471ce40]{outline:none}.yxp-uploader .btn.upload-btn[data-v-7471ce40]{width:80px;border:none;padding:4px 10px;border-radius:4px;cursor:pointer;background-color:#2fd095;color:#fff}.yxp-uploader .btn.upload-btn[data-v-7471ce40]:hover{background-color:#1c976a}.yxp-uploader input[data-v-7471ce40]{display:none}", ""]);

// exports
